import { render, staticRenderFns } from "./AnnouncementFeed.vue?vue&type=template&id=84cd04f4&scoped=true&"
import script from "./AnnouncementFeed.vue?vue&type=script&lang=js&"
export * from "./AnnouncementFeed.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementFeed.vue?vue&type=style&index=0&id=84cd04f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84cd04f4",
  null
  
)

export default component.exports